import React from 'react';
import { useSelector } from 'react-redux';

const RenderTimeInfo = () => {
  const { activeBtn, cleanTs } = useSelector((state) => state);
  const cleanTsDate = new Date(cleanTs);
  const dateWithLocalOffset = new Date(
    cleanTsDate.setMinutes(
      cleanTsDate.getMinutes() - cleanTsDate.getTimezoneOffset()
    )
  );

  if (activeBtn === 'stop') {
    return (
      <>
        <b>Cleaning in progress...</b>
        <p>
          <b>Started (UTC): </b>
          <span> {cleanTs} </span>
        </p>
      </>
    );
  } else if (activeBtn === 'start') {
    return (
      <>
        <b>Last time cleaned: </b>
        <span>{dateWithLocalOffset.toLocaleString()}</span>
      </>
    );
  } else {
    return (
      <>
        <b>Loading data...</b>
      </>
    );
  }
};

export default RenderTimeInfo;
